"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asset_accessor_1 = require("../asset-accessor");

var ContentfulImageAccessor =
/** @class */
function () {
  function ContentfulImageAccessor(base) {
    this.base = base;
  }

  ContentfulImageAccessor.prototype.asset = function () {
    // TODO(benjamin): Needs implementation
    return new asset_accessor_1.NullAssetAccessor();
  };

  ContentfulImageAccessor.prototype.metadata = function () {
    // TODO(benjamin): Needs implementation
    return {};
  };

  ContentfulImageAccessor.prototype.fluid = function (opts) {
    // TODO(benjamin): Needs implementation
    return undefined;
  };

  return ContentfulImageAccessor;
}();

exports.ContentfulImageAccessor = ContentfulImageAccessor;